import React, { useEffect, useState } from 'react'
import { Link, NavLink, withRouter } from 'react-router-dom'
import { Badge, Popover, Row, Col, Spin, Avatar, message } from 'antd'

import './HeaderScout.scss'
import logo from '../../../assets/images/LogoExitFund.svg'
import LogoMobile from '../../../assets/images/scouts/exitfund_logo.jpg'

import { Container, Nav, Navbar } from 'react-bootstrap'
import Bell from '../../../assets/images/scouts/bell.svg'
import copyClipboard from '../../../assets/images/scouts/copyClipboard.svg'
import empty_notification_icon from '../../../assets/images/scouts/empty_notification_icon.svg'
import ProfileToggle from '../../../pages/ScoutPortal/ScoutProfile/components/ProfileToggle'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchProfileData,
  fetchUnreadNotificationCount,
  fetchUnreadNotifications,
  clearScoutNotifications,
} from '../../../redux/scoutFlowControl/scoutFlowControlActions'
import moment from 'moment'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import useMediaQuery from 'use-mediaquery'

// Header component for the Scout section.
const HeaderScout = ({ history, location }) => {
  const matches = useMediaQuery('(min-width: 991px)')
  const dispatch = useDispatch()
  const profileData = useSelector(state => state?.scoutflowControl?.profile_data)
  const unread_notification_count = useSelector(state => state?.scoutflowControl?.unread_notification_count)
  const unreadNotifications = useSelector(state => state?.scoutflowControl?.unreadNotifications)
  const loading = useSelector(state => state?.scoutflowControl?.loading)
  const [unread, setUnread] = useState(0)

  // Update the unread notification count.
  useEffect(() => {
    setUnread(unread_notification_count)
  }, [unread_notification_count])

  // Fetch the profiledata & unread notifications count
  useEffect(() => {
    if (!profileData || Object.keys(profileData)?.length <= 0) {
      dispatch(fetchProfileData())
    }
  }, [profileData])
  useEffect(() => {
    dispatch(fetchUnreadNotificationCount())
  }, [location.pathname])

  /**
   * Handles the visibility change of the notification popover.
   *
   * @param {boolean} visibility - Popover visibility.
   */
  const VisibleChangeHandler = visiblity => {
    if (!visiblity) {
      setUnread(0)
    }
  }

  // Handles the click event for the notification icon.
  const onNotificationClick = () => {
    dispatch(fetchUnreadNotifications())
  }

  // Handles the click event to clear all notifications.
  const onClearNotification = () => {
    dispatch(clearScoutNotifications())
  }

  // Notification popover content.
  const notifications = (
    <div className="notifications-content-wrapper">
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="pop-header">
            <h4>Notification</h4>
            <span className="clear-all" onClick={onClearNotification}>
              Clear all
            </span>
          </div>
          <div className="pop-content">
            {unreadNotifications?.map(item => (
              <div className="line-hr">
                <Row gutter={12}>
                  <Col span={4}>
                    <div className="alignments">
                      <Avatar src={item?.profile_pic}>{item?.first_name?.[0]?.toUpperCase() || 'N'}</Avatar>
                    </div>
                  </Col>
                  <Col span={18}>
                    <div className="alignments">
                      <span className="notification-msg">{item?.activity}</span>
                      <span className="timing">{moment(item?.timestamp).utc(true).fromNow()}</span>
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
          <div className="pop-footer">
            <span
              onClick={() => {
                setUnread(0)
                history.push('/scout/notifications')
              }}
            >
              View All
            </span>
          </div>
        </>
      )}
    </div>
  )

  // Empty notification popover content.
  const emptyNotificationContent = (
    <>
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 100,
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.4,
            background: 'white',
          }}
        >
          <Spin />
        </div>
      )}
      <div className="empty-scout-nootification-content-wrap">
        <div className="pop-header">
          <h4>Notification</h4>
          <span className="clear-all" onClick={() => history.push('/scout/notifications')}>
            View all
          </span>
        </div>
        <div className="pop-content">
          <img src={empty_notification_icon} alt="" />
          <span className="no-notification-text">No new notifications</span>
        </div>
      </div>
    </>
  )

  return (
    <div className="toolbar sticky-top w-100">
      <div className="header m-0">
        <Navbar expand="lg" className="w-100 ">
          <Container className="headerTop" fluid>
            <Navbar.Brand className="left">
              <NavLink style={{ textDecoration: 'none' }} to="/scout/invite">
                <div className="logo" id="home-logo">
                  <img
                    src={matches ? logo : LogoMobile}
                    className=""
                    alt="Logo - Exitfund"
                    style={{ height: '45px', width: 'auto' }}
                  />
                </div>
              </NavLink>
            </Navbar.Brand>
            <div className="d-none d-lg-block">
              <Navbar id="basic-navbar-nav" className="d-md-flex d-sm-block justify-content-center">
                <Nav className="d-flex justify-content-center">
                  <Nav
                    className={`text-dark px-2 ${location?.pathname === '/scout/invite' ? 'active' : null}`}
                  >
                    <Link to="/scout/invite">Invite</Link>
                  </Nav>
                  <Nav
                    className={`text-dark px-2 ${location?.pathname === '/scout/deals' ? 'active' : null}`}
                  >
                    <Link to="/scout/deals">Deals</Link>
                  </Nav>
                  <Nav
                    className={`text-dark px-2 ${
                      location?.pathname === '/scout/referrals' ? 'active' : null
                    }`}
                  >
                    <Link to="/scout/referrals">Referrals</Link>
                  </Nav>
                  <Nav
                    className={`text-dark px-2 ${
                      location?.pathname === '/scout/contracts' ? 'active' : null
                    }`}
                  >
                    <Link to="/scout/contracts">Contracts</Link>
                  </Nav>
                </Nav>
              </Navbar>
            </div>

            <div className="d-flex align-items-center">
              <div className="invite-code-wrap mr-4">
                <span>{profileData?.invite_code}</span>
                <CopyToClipboard
                  text={profileData?.invite_code}
                  onCopy={() => message.success('Copied to clipboard')}
                >
                  <img role="button" className="ml-3" src={copyClipboard} alt="" />
                </CopyToClipboard>
              </div>
              <div style={{ position: 'relative' }}>
                <Popover
                  arrowContent={null}
                  content={unreadNotifications?.length > 0 ? notifications : emptyNotificationContent}
                  placement="bottomRight"
                  trigger="click"
                  overlayClassName="notifications-popover-container-scout"
                  onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
                  align={{
                    offset: [4, 4],
                  }}
                >
                  <Badge count={unread} onClick={() => onNotificationClick()} className="mr-3">
                    <img src={Bell} alt="" />
                  </Badge>
                </Popover>
              </div>
              <ProfileToggle profileData={profileData} />
            </div>
          </Container>
        </Navbar>
      </div>
    </div>
  )
}

export default withRouter(HeaderScout)
